import * as Joi from 'joi';

export const UpdateSettlementStatusToDoneSchema = Joi.object({
  payoutDate: Joi.date().required().messages({
    'any.required': 'payoutDate is required.',
  }),
});
